import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Flex, SvgIcon, Text } from 'Components/Base';

import { CloseSVGIcon } from './CloseSVGIcon';

const EmptySearchResult = (props) => {
  const { t } = useTranslation('myCourses');

  return (
    <Flex flexDirection="column" alignItems="center" justifyContent="center" {...props}>
      <Box style={{ position: 'relative' }}>
        <Box style={{ position: 'absolute', top: '20px', left: '0px' }}>
          <CloseSVGIcon strokeWidth="1" />
        </Box>
        <SvgIcon icon={SvgIcon.ICON_LIST.SEARCH} size={56} color="notiGrey.grey1" />
      </Box>

      <Text mt={4} textAlign="center">
        {t('COURSE_LIST.EMPTY.EMPTY_SEARCH_RESULT')}
      </Text>
    </Flex>
  );
};

export default EmptySearchResult;
